import React from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import { toaster } from 'evergreen-ui';
import { isAdminSelector, isLocalAdminSelector } from 'Services/auth.service';
import Logs from 'Features/Settings/Settings.Users/Users.Logs';
import NotificationsArchive from 'Features/Notifications/Notifications.Archive';
import { timeZoneSelector } from 'Features/App/appSlice';
import { MessagesTabs } from '../../Stations/Station/Messages/Messages.Tabs';
import { EventsErrorsMessages } from './Events.ErrorsMessages';
import DevicesDevices from '../Settings.Devices/Devices.Devices';
import ChannelsTableList from '../Settings.Common/Common.Channels/ChannelsTableList';

const RegistryEvents = React.lazy(() => import('./Events.RegistryEvents'));

export default function SettingsEventsRouter() {
  const isAdmin = useSelector(isAdminSelector);
  const selectedZone = useSelector(timeZoneSelector);
  const isLocalAdmin = useSelector(isLocalAdminSelector);

  React.useEffect(() => {
    if (!isAdmin) toaster.warning('Нет прав для просмотра настроек!');
  }, [isAdmin]);

  React.useEffect(() => {
    if (!isAdmin && !isLocalAdmin) toaster.warning('Нет прав для просмотра настроек!');
  }, [isAdmin, isLocalAdmin]);

  if (!isAdmin && !isLocalAdmin) return <Navigate to="/" />;
  return (
    <Routes>
      <Route
        path="events"
        element={<RegistryEvents />}
      />

      <Route
        path="actions-user"
        element={<Logs />}
      />

      <Route
        path="notifications"
        element={(
          <NotificationsArchive isSettings />
        )}
      />

      <Route path="/unsent-messages/*" element={<MessagesTabs isArchive />}>
        <Route path="/*" element={<EventsErrorsMessages />} />
      </Route>

      <Route
        path="devices"
        element={<DevicesDevices />}
      />

      <Route
        path="channels-statistics"
        element={(
          <ChannelsTableList isChannelStatistic />
        )}
      />

      <Route path="*" element={<Navigate to="events" replace />} />
    </Routes>
  );
}
